const React = require("react");
const PT = require("prop-types");
const createReactClass = require("create-react-class");
const _ = require("lodash");

const LoadState = require("../../core/vault/util/LoadState");
const withVaultUpdate = require("../../core/hoc/withVaultUpdate");
const EditPencil = require("../../office/EditPencil");
const OfficeModal = require("../../office/modals/OfficeModal");
const LoadingCircle = require("../../core/view/LoadingCircle");

const CopyTable = require("../../office/data/CopyTable");

const styles = require("./styles/EditableAddressCard.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultUpdate(Component);
	return Component;
};

module.exports = augment(
	createReactClass({
		displayName: "EditableField",

		propTypes: {
			className: PT.string,
			title: PT.string,
			fieldType: PT.string.isRequired,
			placeholder: PT.string,
			onUpdate: PT.func.isRequired,
			text: PT.string,
			textClass: PT.string,
			maxFieldLength: PT.number,
		},

		vaultEvents: {
			parentFormSuccess: function() {
				this.setState({
					isLoading: false,
					isModalOpen: false,
					errorType: null,
				});
			},
			parentFormValidationFail: function(validation) {
				this.setState({
					isLoading: false,
					errorType: _.get(
						validation,
						["errorTypes", this.props.fieldType, "type"],
						null
					),
				});
			},
			parentFormFail: function(error) {
				let errorMessage = null;
				if (LoadState.shouldRetry(error)) {
					errorMessage =
						"There was an issue connecting to the server. Please try again.";
				} else {
					errorMessage =
						"There was an issue saving your information. Please try again.";
				}
				this.setState({
					isLoading: false,
					errorType: null,
					errorMessage,
				});
			},
			parentStudentInfoSuccess: function() {
				this.setState({
					isLoading: false,
					isModalOpen: false,
					errorType: null,
				});
			},
			parentStudentInfoFail: function(error) {
				let errorMessage = null;
				if (LoadState.shouldRetry(error)) {
					errorMessage =
						"There was an issue connecting to the server. Please try again.";
				} else {
					errorMessage =
						"There was an issue saving your information. Please try again.";
				}
				this.setState({
					isLoading: false,
					errorType: null,
					errorMessage,
				});
			},
			parentInvalidDisplayName: function(name, error) {
				this.setState({
					isLoading: false,
					errorType: error,
				});
			},
		},

		getInitialState: function() {
			return {
				isModalOpen: false,
				value: "",
				isLoading: false,
				errorType: null,
				errorMessage: null,
			};
		},

		openModal: function() {
			//Open & clear any old errors
			this.setState({
				isModalOpen: true,
				errorType: null,
				errorMessage: null,
			});
		},

		closeModal: function() {
			this.setState(this.getInitialState());
		},

		onUpdate: function() {
			this.props.onUpdate(this.state.value);
			this.setState({
				isLoading: true,
			});
		},

		getKeyHandler: function(f) {
			return evt => {
				if (evt.which === 13) {
					f();
				}
			};
		},

		handleChange: function(evt) {
			this.setState({value: evt.target.value});
		},

		renderInput: function(type, tabIndex) {
			let inputClass = styles.input;
			if (this.state.errorType) inputClass += " " + styles.invalid;
			return (
				<input
					className={inputClass}
					type={this.props.fieldType}
					placeholder={this.props.placeholder}
					value={this.state.value}
					onChange={this.handleChange}
					onKeyPress={this.handleKeyPress}
					tabIndex={tabIndex}
					maxLength={this.props.maxFieldLength}
				/>
			);
		},

		renderContents: function() {
			return this.renderInput("phone", 51);
		},

		render: function() {
			const {isLoading, errorType} = this.state;
			const {className, fieldType, title, text, textClass} = this.props;

			const errorMessage =
				this.state.errorMessage ||
				(errorType ? CopyTable.getFormInvalidCopy(fieldType)[errorType] : "");

			const belowContents = (
				<div className={errorMessage ? styles.error : styles.errorHidden}>
					{errorMessage}
				</div>
			);

			let saveButton = (
				<div
					className={styles.button}
					onClick={this.onUpdate}
					tabIndex={53}
					onKeyPress={this.getKeyHandler(this.onUpdate)}
				>
					Save Changes
				</div>
			);
			const cancelButton = (
				<div
					className={styles.button}
					onClick={this.closeModal}
					tabIndex={54}
					onKeyPress={this.getKeyHandler(this.closeModal)}
				>
					Cancel
				</div>
			);
			if (isLoading) {
				saveButton = (
					<div className={styles.loadingContainer}>
						<div className={styles.loading}>
							<LoadingCircle colorType="white" />
						</div>
					</div>
				);
			}
			let editModal = null;
			if (this.state.isModalOpen) {
				editModal = (
					<OfficeModal
						onClose={this.closeModal}
						closeOnEsc={true}
						portalContainer={null}
						level="overBar"
						modalClass={styles.fieldModal}
					>
						<div className={styles.fieldContainer}>
							<div className={styles.title}>{title}</div>
							{this.renderContents()}
							{belowContents}
							<div className={styles.buttonRow}>
								{saveButton}
								{cancelButton}
							</div>
						</div>
					</OfficeModal>
				);
			}

			let mainClass = styles.mainSingle;
			if (className) mainClass += " " + className;
			let textClassName = styles.text;
			if (textClass) textClassName += " " + textClass;

			return (
				<div className={mainClass}>
					<EditPencil onClick={this.openModal} />
					<div className={textClassName}>{text}</div>
					{editModal}
				</div>
			);
		},
	})
);
